import { AUDIO_EXTENSIONS, canPlay } from '../../../constants';
import { supportsWebKitPresentationMode } from '../utils';
import { DailyMotion } from './DailyMotion';
import { Facebook } from './Facebook';
import { FilePlayer } from './FilePlayer';
import { Mixcloud } from './Mixcloud';
import { SoundCloud } from './SoundCloud';
import { Streamable } from './Streamable';
import { Twitch } from './Twitch';
import { Vimeo } from './Vimeo';
import { Wistia } from './Wistia';
import { YouTube } from './YouTube';

const players = [
  {
    key: 'file',
    name: 'FilePlayer',
    canPlay: canPlay.file,
    canEnablePIP: (url: string) => {
      return (
        canPlay.file(url) &&
        (document.pictureInPictureEnabled ||
          supportsWebKitPresentationMode()) &&
        !AUDIO_EXTENSIONS.test(url)
      );
    },
    player: FilePlayer
  },
  {
    key: 'youtube',
    name: 'YouTube',
    canPlay: canPlay.youtube,
    player: YouTube
  },
  {
    key: 'soundcloud',
    name: 'SoundCloud',
    canPlay: canPlay.soundcloud,
    player: SoundCloud
  },
  {
    key: 'facebook',
    name: 'Facebook',
    canPlay: canPlay.facebook,
    player: Facebook
  },
  {
    key: 'twitch',
    name: 'Twitch',
    canPlay: canPlay.twitch,
    player: Twitch
  },
  {
    key: 'vimeo',
    name: 'Vimeo',
    canPlay: canPlay.vimeo,
    player: Vimeo
  },
  {
    key: 'mixcloud',
    name: 'Mixcloud',
    canPlay: canPlay.mixcloud,
    player: Mixcloud
  },
  {
    key: 'dailymotion',
    name: 'DailyMotion',
    canPlay: canPlay.dailymotion,
    player: DailyMotion
  },
  {
    key: 'wistia',
    name: 'Wistia',
    canPlay: canPlay.wistia,
    player: Wistia
  },
  {
    key: 'streamable',
    name: 'Streamable',
    canPlay: canPlay.streamable,
    player: Streamable
  }
];

export default players;
